/**
 * TemplateFactory Component
 *
 * Dynamically renders the appropriate dashboard template based on template_id.
 */

import PropTypes from 'prop-types';
import FourColumnsThreeRows from './FourColumnsThreeRows';
import FourColumnsFourRows from './FourColumnsFourRows';
import FourTopBottomTwoSection from './FourTopBottomTwoSection';
import TwoRowsTwoFullWidth from './TwoRowsTwoFullWidth';
import OneLeftRightThreeSection from './OneLeftRightThreeSection';

const TemplateFactory = ({ templateId, elements, chartsConfig, dashboardId }) => {
  if (!templateId) {
    return (
      <div className="template-error">
        <p>Error: No template ID provided</p>
      </div>
    );
  }

  if (!elements) {
    return (
      <div className="template-error">
        <p>Error: No elements configuration provided</p>
      </div>
    );
  }

  // Normalize template_id (handle snake_case and other formats)
  const normalizedTemplateId = templateId.toLowerCase().replace(/-/g, '_');

  // Route to appropriate template component
  switch (normalizedTemplateId) {
    case 'four_columns_three_rows':
    case 'fourcolumnsthreerows':
      return (
        <FourColumnsThreeRows elements={elements} chartsConfig={chartsConfig} dashboardId={dashboardId} />
      );

    case 'four_columns_four_rows':
    case 'fourcolumnsfourrows':
      return (
        <FourColumnsFourRows elements={elements} chartsConfig={chartsConfig} dashboardId={dashboardId} />
      );

    case 'four_top_bottom_two_section':
    case 'fourtopbottomtwosection':
      return (
        <FourTopBottomTwoSection elements={elements} chartsConfig={chartsConfig} dashboardId={dashboardId} />
      );

    case 'two_rows_two_full_width':
    case 'tworowstwofullwidth':
      return (
        <TwoRowsTwoFullWidth elements={elements} chartsConfig={chartsConfig} dashboardId={dashboardId} />
      );

    case 'one_left_right_three_section':
    case 'oneleftrightthreesection':
      return (
        <OneLeftRightThreeSection elements={elements} chartsConfig={chartsConfig} dashboardId={dashboardId} />
      );

    default:
      return (
        <div className="template-not-implemented">
          <h4>Template: {templateId}</h4>
          <p>This dashboard template is not yet implemented.</p>
          <pre>{JSON.stringify(elements, null, 2)}</pre>
        </div>
      );
  }
};

TemplateFactory.propTypes = {
  templateId: PropTypes.string.isRequired,
  elements: PropTypes.object.isRequired,
  chartsConfig: PropTypes.array,
  dashboardId: PropTypes.string,
};

TemplateFactory.defaultProps = {
  chartsConfig: [],
  dashboardId: null,
};

export default TemplateFactory;
